(function () {
  'use strict';

  angular
    .module('oqs')
    .config(config);

  config.$inject = ['$urlRouterProvider', 'uiGmapGoogleMapApiProvider', '$logProvider', '$compileProvider', 'ENV'];

  function config($urlRouterProvider, uiGmapGoogleMapApiProvider, $logProvider, $compileProvider, ENV) {
    console.log('OqsConfig is: ' + ENV);
    if (ENV !== 'dev') {
      $logProvider.debugEnabled(false);
      $compileProvider.debugInfoEnabled(false);
    }
    $urlRouterProvider.otherwise('/quote/');
    uiGmapGoogleMapApiProvider.configure({
      client: 'gme-masterconceptcomputer',
      v: '3',
      libraries: 'geometry'
    });
  }
}());
